import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { switchMap, tap } from 'rxjs/operators';
import { CanBeRefundedRequest, CanBeRefundedSalesDocumentItemRequest } from 'libs/core/src/lib/model/request/order-refund.request.models';
import { RefundModalContent, RefundModalFailedContent, RefundModalSuccessContent, RefundTypeEnum } from '@lib/shared';
import { BaseRefundComponent } from '../base-refund.component';
import { LoaderStatus } from '@lib/core';
import { TransactionNumberByVoucherNumber } from 'libs/core/src/lib/model/interface/transaction-number-by-voucher-number.interface';

@Component({
  template: ''
})
export class RefundVouchersComponent extends BaseRefundComponent {
  @Input() public formValues: { voucherNo?: string; email?: string };

  content: RefundModalContent = {
    refundType: RefundTypeEnum.Vouchers,
    items: []
  };

  private cinemaId: string;
  private salesDocumentId: string;
  private voucherNo: string;
  private email: string;

  override readFormFields(form: FormGroup) {
    const { voucherNumber, email, cinemaId } = form.value;
    if (!voucherNumber) {
      this.changeLoaderState(LoaderStatus.stopped);
      return;
    }

    this.voucherNo = voucherNumber;
    this.email = email;

    this.startRefundProcess();
  }

  private createCanBeRefundedRequest(result: TransactionNumberByVoucherNumber): CanBeRefundedRequest {
    const canBeRefundedRequest = new CanBeRefundedRequest(this.email);
    const item = new CanBeRefundedSalesDocumentItemRequest();
    item.id = result.salesDocumentItemId;
    item.quantity = 1;
    item.purchasedVoucherNumbers = [this.voucherNo];
    canBeRefundedRequest.salesDocumentItemList = [item];
    return canBeRefundedRequest;
  }

  private startRefundProcess() {
    this.refundDataProvider
      .getTransactionNumberByVoucherNumber(this.voucherNo)
      .pipe(
        tap((result: TransactionNumberByVoucherNumber) => {
          this.salesDocumentId = result.salesDocumentId;
          this.cinemaId = result.cinemaId;
        }),
        switchMap((result: TransactionNumberByVoucherNumber) =>
          this.refund(this.cinemaId, this.email, this.salesDocumentId, this.createCanBeRefundedRequest(result))
        )
      )
      .subscribe({
        next: (refundResponse) => {
          //TODO dodać obsługę GTM jeśli będzie wymagane

          this.displaySuccess({ refundedItemsCount: 1, allItemsCount: 1 });
        },
        error: (e) => {
          this.displayFail(this.mapError(e));
        }
      });
  }

  private displayFail(failedContent: RefundModalFailedContent = {}) {
    this.content.failedContent = {
      ...failedContent
    };

    this.displayModal('fail');
  }

  private displaySuccess(successContent?: RefundModalSuccessContent) {
    this.content.successContent = {
      ...successContent
    };

    this.displayModal('success');
  }
}
